import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class CompatRedirectGuard implements CanActivate {
  initialRouteLoaded = false;
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (!this.initialRouteLoaded) {
      this.initialRouteLoaded = true;
      return true;
    }
    if (window.location.hostname === 'localhost') {
      window.location.assign(`https://www.syd1.fln-dev.net${state.url}`);
    } else {
      window.location.assign(state.url);
    }
    return <Observable<boolean>>Observable.never();
  }
}



// WEBPACK FOOTER //
// ./src/compat/compat-redirect-guard.service.ts